import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import TreeView, {TreeViewRef} from 'devextreme-react/tree-view';
import { navigation } from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './SideNavigationMenu.scss';
import type { SideNavigationMenuProps } from '../../types';

import * as events from 'devextreme/events';

export default function SideNavigationMenu(props: React.PropsWithChildren<SideNavigationMenuProps>) {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const { isLarge } = useScreenSize();

  function normalizePath() {
    return navigation.map((item) => (
      { ...item, expanded: isLarge, path: item.path }
    ))
  }

  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const { navigationData: { currentPath } } = useNavigation();
  const treeViewRef = useRef<TreeViewRef>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const getWrapperRef = useCallback((element: HTMLDivElement) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      // events.off(prevElement, 'mouseleave');
      events.off(prevElement, 'dxclick');
      events.off(prevElement, 'mouseover');
    }
    wrapperRef.current = element;
    events.on(element, 'mouseover', (e: React.PointerEvent) => {
      openMenu(e);
    });
    events.on(element, 'dxclick', (e: React.PointerEvent) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.instance().selectItem(currentPath);
      treeView.instance().expandItem(currentPath);
    }

    if (compactMode) {
      treeView.instance().collapseAll();
    }
  }, [currentPath, compactMode]);

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      {/* <h2>Flexbox Item With overflow: hidden </h2> */}
      <div className={'menu-container'}>
        <TreeView
          searchEnabled={true}
          searchEditorOptions={{
            placeholder: compactMode ? "" : "Recherche"
          }}
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
